import styled from "styled-components"

export const Container = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    color: white;
    background-color: #313131;
    box-shadow: 1px 1px 20px black;
    padding: 10px 0px;
`

export const Home = styled.div `
    cursor: pointer;

    button {
        cursor: pointer;
        margin-left: 20px;
        background-color: transparent;

        svg {
            width: 25px;
            height: 25px;
            color: #FFFFFF;
        }

        :hover {
            transition-duration: 0.5s;
            color: #131313;
        }
    }
`

export const Options = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    button {
        cursor: pointer;
        margin-left: 20px;
        background-color: transparent;

        svg {
            width: 25px;
            height: 25px;
            color: #FFFFFF;
        }

        :hover {
            transition-duration: 0.5s;
            color: #131313;
        }
    }
`